import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { Observable } from 'rxjs';

import { Booking } from './booking';
import { BookingsStore } from './bookings.store';

@Injectable()
export class BookingResolver  {

    constructor(private store: BookingsStore) { }

    resolve(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<Booking> {
        const id = route.paramMap.get('id');
        return this.store.getWithDependencies(id);
    }
}
